import { MultiTesterAspect } from './multi-tester.aspect';

export { MultiTesterAspect };
export type { MultiTesterMain } from './multi-tester.main.runtime';
export type { MultiTester } from './multi-tester.tester';
export default MultiTesterAspect;
